import React from 'react';

const AssignViewNoProfileContext = React.createContext(false);

export default AssignViewNoProfileContext;
